module.exports = __webpack_public_path__ + "img/story012@2x.8d062015.png";